import { Injectable } from '@angular/core';

import { type Translation, type TranslocoInterceptor } from '@jsverse/transloco';
import { isPseudoLocaleEnabled, wrapPseudoLocale } from './pseudo-locale';

@Injectable()
export class AmpPseudoLocaleInterceptor implements TranslocoInterceptor {
  preSaveTranslation(translation: Translation): Translation {
    if (!isPseudoLocaleEnabled()) {
      return translation;
    }

    return wrapTranslationTree(translation) as Translation;
  }

  preSaveTranslationKey(_key: string, value: string): string {
    return isPseudoLocaleEnabled() ? wrapPseudoLocale(value) : value;
  }
}

function wrapTranslationTree(value: unknown): unknown {
  if (typeof value === 'string') {
    return wrapPseudoLocale(value);
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nested]) => [key, wrapTranslationTree(nested)]),
    );
  }

  return value;
}
